import StockCreate from './StockCreate'
export {StockCreate}
export default StockCreate
